if (!customElements.get("custom-reviews-slider")) {
  class customReviewsSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.slider = this.querySelector(".custom-reviews-slider__slider");
      this.navigation = this.querySelector(
        ".custom-reviews-slider__navigation"
      );
      this.prevBtn = this.querySelector(".swiper-button-prev");
      this.nextBtn = this.querySelector(".swiper-button-next");
      if (!this.slider) return;
      this.initSlider();
    }

    initSlider() {
      this.swiper = new Swiper(this.slider, {
        spaceBetween: 9,
        slidesPerView: 1.5,
        grabCursor: true,

        navigation: {
          nextEl: this.nextBtn,
          prevEl: this.prevBtn,
        },

        breakpoints: {
          450: {
            spaceBetween: 8,
            slidesPerView: 2.43,
          },
          767: {
            spaceBetween: 12,
            slidesPerView: 3.45,
          },
          1200: {
            spaceBetween: 13,
            slidesPerView: 4,
          },
        },

        on: {
          init: (swiper) => this.toggleNavigationVisibility(swiper),
          resize: (swiper) => this.toggleNavigationVisibility(swiper),
        },
      });
    }

    toggleNavigationVisibility(swiper) {
      const totalSlides = swiper.slides.length;
      const slidesPerView = swiper.params.slidesPerView;

      const isFractional =
        typeof slidesPerView === "number"
          ? slidesPerView
          : swiper.params.breakpoints?.[swiper.currentBreakpoint]
              ?.slidesPerView;

      if (totalSlides <= isFractional) {
        this.navigation.style.display = "none";
      } else {
        this.navigation.style.display = "";
      }
    }
  }

  customElements.define("custom-reviews-slider", customReviewsSlider);
}
